import { createModal } from '/@/core/elements/modal'
import type { ProjectBudget, ProjectThingBudget } from '../types'
import type {
  Product,
  ProjectGenericThing,
  ProjectProduct,
} from '/@/common/things/types'
import type {
  ProjectInfo,
  ProjectProductDisplayType,
} from '/@/common/projects/types'
import type { ViewerType } from '/@/utils/misc'
import type { BudgetColumnType } from '../utils'
import { isProjectThing } from '../../things/utils'

export interface ReviewBudgetModalData {
  budget: ProjectBudget
}

const { api: useReviewBudgetModal, component: ReviewBudgetModal } =
  createModal<ReviewBudgetModalData>(
    'ReviewBudgetModal',
    () => import('./ReviewBudgetModal.vue'),
  )

export interface EditBudgetItemModalData {
  project: ProjectInfo
  projectThing: ProjectProduct | ProjectGenericThing
  budget: ProjectThingBudget
  productDisplayType: ProjectProductDisplayType
  viewer: ViewerType
  initialInputType?: BudgetColumnType
  trackingContext: string | undefined
}

const { api: useEditBudgetItemModal, component: EditBudgetItemModal } =
  createModal<EditBudgetItemModalData>(
    'EditBudgetItemModal',
    () => import('./EditBudgetItemModal.vue'),
  )

export interface AddBudgetItemModalData {
  project: ProjectInfo
  thing: Product | ProjectProduct | ProjectGenericThing
  productDisplayType: ProjectProductDisplayType
  viewer: ViewerType
  trackingContext: string | undefined
}

const { api: useAddBudgetItemModal, component: AddBudgetItemModal } =
  createModal<AddBudgetItemModalData>(
    'AddBudgetItemModal',
    () => import('./AddBudgetItemModal.vue'),
  )

export function getInitialPricePerItemCents(product: Product | ProjectProduct) {
  if (isProjectThing(product)) {
    const customPrice = product.price
    if (customPrice) {
      const matches = customPrice.match(/[+-]?\d+(\.\d+)?/g)
      if (matches && matches.length > 0) {
        const parsedValue = parseFloat(matches[0])
        if (parsedValue && !isNaN(parsedValue)) {
          return Math.round(parsedValue * 100)
        }
      }
    }
    product = product.product
  }
  return product.minPriceCent ?? product.maxPriceCent ?? 0
}

export {
  useReviewBudgetModal,
  ReviewBudgetModal,
  useEditBudgetItemModal,
  EditBudgetItemModal,
  useAddBudgetItemModal,
  AddBudgetItemModal,
}
